import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the record table agent list view.
 */
export default class recordTableAgentListView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance

        // Window for filter details
        const filterDetails = webix.ui({
            view: 'window',
            move: true,
            id: 'filterDetails',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Historial de gestiones'), // Title label
                        align: 'center',
                    },
                    {
                        view: 'button',
                        label: _('Crear Nota'), // Button to create a note
                        width: 100,
                        click: () => {
                            this.app.callEvent('managementContact:openModal', []); // Opens modal for creating a note
                        },
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hides the window
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'datatable', // Data table for displaying details
                id: 'dtDetails',
                css: 'webix_header_border webix_data_border webix_footer_border',
                select: true,
                columns: [
                    { id: 'Id', header: 'Id', width: 70, sort: 'int' },
                    {
                        id: 'Date',
                        header: _('Fecha/hora'), // Date/Time column
                        width: 150,
                        sort: 'int',
                    },
                    {
                        id: 'User',
                        header: _('Usuario'), // User column
                        width: 100,
                        sort: 'int',
                    },
                    { id: 'Text', header: _('Texto'), width: 300, sort: 'int' }, // Text column
                ],
            },
        });

        // Main data table configuration
        return {
            view: 'datatable',
            id: 'datatable1',
            css: 'webix_header_border webix_data_border webix_footer_border',
            select: true,
            columns: [
                { id: 'Id', header: 'Id', width: 70, sort: 'int' },
                {
                    id: 'Date',
                    header: _('Fecha/hora'), // Date/Time column
                    width: 150,
                    sort: 'int',
                },
                { id: 'User', header: _('Usuario'), width: 100, sort: 'int' }, // User column
                { id: 'Text', header: _('Texto'), width: 300, sort: 'int' }, // Text column
            ],
            onClick: {
                edit: function (euv, id) {
                    var item = this.getItem(id); // Get the clicked item
                    vthis.app.callEvent('managementContact:id', [item]); // Trigger event with item data
                    $$('response-request').show(); // Show response request popup
                },
            },
            pager: 'pagerA', // Pager for the data table
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The data table grid.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        var url = devConfig.geturlApi() + 'Management/GetManagementContactDetails'; // API URL for fetching details
        var idRequirements; // Placeholder for requirements ID
        var action; // Placeholder for action
        var vthis = this; // Reference to the current instance
        var detailsId; // Placeholder for details ID

        // Event listener for loading management contact details
        this.on(this.app, 'detailsManagementContact:id', (Id) => {
            grid.clearAll(); // Clear the grid
            grid.load(url + '?id=' + Id); // Load data into the grid
            $$('dtDetails').clearAll(); // Clear details data table
            $$('dtDetails').load(url + '?id=' + Id); // Load details data
            detailsId = Id; // Store the details ID
        });

        // Popup for responding to requests
        var popup = webix.ui({
            view: 'window',
            id: 'response-request',
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Responder Solicitud'), // Popup title
                        id: 'lblPopup',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hides the popup
                        },
                    },
                ],
            },
            position: 'center',
            modal: true,
            body: {
                view: 'form', // Form for response input
                id: 'addResponse',
                elements: [
                    {
                        view: 'textarea',
                        name: 'Response', // Response input field
                        placeholder: _('Respuesta'), // Placeholder text
                        required: true, // Field is required
                        invalidMessage: _('Campo Requerido'), // Error message for required field
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'), // Cancel button
                                click: function () {
                                    this.getTopParentView().hide(); // Hides the popup
                                    $$('addResponse').setValues(
                                        $$('addResponse').getCleanValues(), // Resets form values
                                    );
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                id: 'buttonResponse',
                                value: _('Guardar'), // Save button
                                click: function ($e) {
                                    var values = $$('addResponse').getValues(); // Get form values
                                    var date = // Constructing the current date string
                                        webix.Date.add(new Date(), 0, 'day').getFullYear() +
                                        ':' +
                                        ('00' + (webix.Date.add(new Date(), 0, 'day').getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + webix.Date.add(new Date(), 0, 'day').getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + webix.Date.add(new Date(), 0, 'day').getHours()).slice(-2) +
                                        ':' +
                                        ('00' + webix.Date.add(new Date(), 0, 'day').getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + webix.Date.add(new Date(), 0, 'day').getSeconds()).slice(-2);
                                    if (values.Response !== '') {
                                        webix
                                            .ajax()
                                            .headers({
                                                'Content-type': 'application/json', // Setting content type for the request
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Management/ResponseManagementContact',
                                                '{"Id":"' +
                                                    detailsId +
                                                    '", "Response":"' +
                                                    values.Response +
                                                    '", "CreationDate":"' +
                                                    date +
                                                    '"}', // Sending response data
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message on failure
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var json = JSON.parse(text); // Parsing response JSON
                                                        if (json.HasError) {
                                                            webix.message({
                                                                title: '¡Error!',
                                                                type: 'alert-error',
                                                                text: _(
                                                                    'Ocurrio un error, comuniquese con soporte', // Error message for support
                                                                ),
                                                            });
                                                        } else {
                                                            webix.message(
                                                                _(
                                                                    'Nota Generada', // Success message
                                                                ),
                                                            );
                                                            grid.clearAll(); // Clear the grid
                                                            grid.load(
                                                                url +
                                                                    '?id=' +
                                                                    detailsId +
                                                                    '&start=0&count=' +
                                                                    grid.data.$pagesize, // Reload grid data
                                                            );
                                                        }
                                                    },
                                                },
                                            );
                                        $$('addResponse').setValues(
                                            $$('addResponse').getCleanValues(), // Reset form values
                                        );
                                        this.getTopParentView().hide(); // Hide the popup
                                    } else {
                                        webix.message({
                                            text: _('Envie una Respuesta'), // Error message for empty response
                                            title: 'Error!',
                                            type: 'alert-error',
                                        });
                                    }
                                },
                            },
                        ],
                    },
                ],
            },
        });

        var itemSelect; // Placeholder for selected item
        this.on(this.app, 'managementContact:id', (item) => {
            itemSelect = item; // Store selected item
        });
        this.on(this.app, 'managementContact:openModal', (item) => {
            $$('response-request').show(); // Show response request popup
        });
    }
}

// FILE DOCUMENTED
